// Is de app zojuist geopend door in te loggen, of door een pagina te verversen?
//
// Dat verschil bepaalt waar je begint. Verversen hoort je te laten staan waar je was — dat is de
// spa-restore: je typt een zoekopdracht, drukt F5, en staat weer bij je resultaten. Inloggen is iets
// anders: dan begint er een nieuwe werkdag en hoor je op het dashboard te beginnen, niet op het
// scherm waar de vorige sessie toevallig eindigde.
//
// Zonder dit onderscheid liep het mis: de sessie eindigde op de zoekresultaten (of waar dan ook),
// en na het opnieuw inloggen stond je daar weer — met een lege zoekopdracht in een scherm dat niets
// meer betekende.
//
// Waarom sessionStorage en geen variabele in het geheugen: het inloggen zet de vlag vóór de app
// opnieuw opbouwt, en bij een harde herlaadbeurt (na een wachtwoordwissel bijvoorbeeld) overleeft
// een variabele dat niet. sessionStorage hoort bij dit ene tabblad en verdwijnt als het sluit —
// precies de levensduur van een sessie. Elke toegang staat in een try/catch: een browser die opslag
// blokkeert kost ons hooguit deze ene beleefdheid en mag nooit het inloggen breken.

const SLEUTEL = "fawkes:verse-aanmelding";

/** Zet de vlag; aangeroepen door authProvider.login zodra de aanmelding is gelukt. */
export function markeerVerseAanmelding(): void {
  try {
    globalThis.sessionStorage?.setItem(SLEUTEL, "1");
  } catch {
    // Opslag geblokkeerd of vol — dan begin je waar je was. Nooit het inloggen erop laten stuklopen.
  }
}

/**
 * Was dit een verse aanmelding? Leest en wist in één keer, zodat het antwoord maar één keer geldt:
 * de eerstvolgende keer dat de schil zijn beginscherm bepaalt. Zou de vlag blijven staan, dan sprong
 * elke navigatie daarna terug naar het dashboard.
 */
export function neemVerseAanmelding(): boolean {
  try {
    const gezet = globalThis.sessionStorage?.getItem(SLEUTEL) === "1";
    if (gezet) {
      globalThis.sessionStorage?.removeItem(SLEUTEL);
    }
    return gezet;
  } catch {
    return false;
  }
}
